import { render, staticRenderFns } from "./ModalMemo.vue?vue&type=template&id=c59232a2&scoped=true&"
import script from "./ModalMemo.vue?vue&type=script&lang=js&"
export * from "./ModalMemo.vue?vue&type=script&lang=js&"
import style0 from "./ModalMemo.vue?vue&type=style&index=0&id=c59232a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59232a2",
  null
  
)

export default component.exports